import { useEffect } from 'react';

import type { AutoAddType } from '@app/components/RecordModal/components/RecordDetails/types';

export const AutoAdd: AutoAddType = ({ add, fields }) => {
  useEffect(() => {
    if (fields.length === 0) {
      add();
    }
  }, [fields, add]);

  return null;
};
